import React from 'react'

const UserPrevilge = () => {
  return (
    <div>UserPrevilge</div>
  )
}

export default UserPrevilge